<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <h2>Клієнти</h2>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col
          cols="auto"
          class="mb-n7"
        >
          <v-switch
            v-model="outdate"
            color="green"
            label="Тільки прострочені"
            class="mb-n6"
          />
        </v-col>
        <v-col
          cols="auto"
          class="ml-3"
        >
          <v-switch
            v-model="outsourceUpdate"
            color="green"
            label="Оновлюються TQM Systems"
            class="mb-n6"
          />
        </v-col>
        <v-col
          cols="auto"
          class="ml-3"
        >
          <v-switch
            v-model="partnershipStopped"
            color="green"
            label="Співпрацю призупинено"
            class="mb-n6"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="filterInstalled"
            flat
            :loading="loading"
            :footer-props="{itemsPerPageText:'Кількість рядків на сторінці:'}"
            :hide-default-footer="filterInstalled.length < 11"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <ReferenceTitle
                    :id="item.client.id"
                    component-name="Client"
                    :title="item.client.title"
                  />
                </td>
                <td>{{ item.manager ? item.manager.title : '' }}</td>
                <td>{{ item.analyst ? item.analyst.title : '' }}</td>
                <td>{{ item.lastServicePaidTo ? item.lastServicePaidTo : '' | date }}</td>
                <td
                  v-if="!trackVersions"
                >
                  <div class="d-flex align-center">
                    <span :class="{'red--text': !item.upToDate}">
                      {{ item.version }}
                    </span>
                    <v-tooltip
                      v-if="item.version && !item.upToDate"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="red"
                          class="ml-1"
                          v-on="on"
                        >
                          mdi-alert-circle-outline
                        </v-icon>
                      </template>
                      <span>Версія прострочена</span>
                    </v-tooltip>
                  </div>
                </td>
                <td v-if="!trackVersions">
                  <v-chip
                    outlined
                    small
                    :color="item.updateByClient ? 'red' : 'green'"
                  >
                    {{ item.updateByClient ? "Самостійно" : "Tqm Systems" }}
                  </v-chip>
                </td>
                <td>
                  {{ item.notes }}
                </td>
                <td style="width: 18%">
                  <CustomTextField
                    v-model="item.jiraIssueKey"
                    append-icon="search"
                    @change="assignJiraIssue(item)"
                    @click:append="openIssue(item.jiraIssueKey)"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ReferenceTitle from "@/components/ReferenceTitle.vue";
import * as productsApi from "@/backend/productsApi.js";

export default {
  components: {
    ReferenceTitle,
  },
  props: ["id", "trackVersions"],
  data: () => ({
    installed: [],
    outdate: false,
    outsourceUpdate: false,
    partnershipStopped: false,
    loading: false,
  }),
  computed: {
    filterInstalled() {
      let result = [...this.installed];

      if (this.outdate) {
        result = result.filter(s => s.upToDate === false);
      }
      if (this.outsourceUpdate) {
        result = result.filter(s => s.updateByClient === false);
      }

      result = result.filter(s => s.partnershipStopped === this.partnershipStopped);

      return result;
    },
    headers() {
      const headers = [
        { text: "Найменування", align: "left", sortable: false },
        { text: "Менеджер", align: "left", sortable: false },
        { text: "Аналітик", align: "left", sortable: false },
        { text: "ІТС до", align: "left", sortable: false },
        { text: "Версія клієнта", align: "left", sortable: false },
        {
          text: "Оновлення",
          align: "left",
          sortable: false,
        },
        {
          text: "Примітки",
          align: "left",
          sortable: false,
        },
        {
          text: "Код задачі Jira",
          align: "left",
          sortable: false,
          width: "18%",
        },
      ];
      if (this.trackVersions) {
        return headers.filter(({ text }) => !["Оновлення", "Версія клієнта"].includes(text));
      }

      return headers;
    },
  },
  async created() {
    this.loading = true;

    const productInstallations = await productsApi.getProductInstallations(this.id);

    this.installed = productInstallations;

    this.loading = false;
  },
  methods: {
    async assignJiraIssue(installation) {
      this.loading = true;
      await productsApi.assignJiraIssue(installation.client.id, this.id, { JiraIssueKey: installation.jiraIssueKey });
      this.loading = false;
    },
    openIssue(jiraIssueKey) {
      window.open(`https://atominc.atlassian.net/browse/${jiraIssueKey}`, "_blank");
    },
  },
};
</script>
